import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export type ChatSpeaker = 'assistant' | 'caller' | 'system';

export interface ChatBubbleProps {
  speaker: ChatSpeaker;
  /** Displayed speaker name, e.g. "AI" / "Caller". Defaults per speaker. */
  who?: ReactNode;
  /** Timestamp or offset, e.g. "0:12". */
  at?: ReactNode;
  children: ReactNode;
  className?: string;
}

const DEFAULT_WHO: Record<ChatSpeaker, string> = { assistant: 'AI', caller: 'Caller', system: 'System' };

/** One transcript turn. The caller's side is right-aligned and filled; the AI
 *  answers on the left — same shape people know from messaging apps (§7.6). */
export function ChatBubble({ speaker, who, at, children, className }: ChatBubbleProps) {
  return (
    <div className={cx('tc-bubble', `tc-bubble--${speaker}`, className)}>
      <div className="tc-bubble__body">{children}</div>
      <div className="tc-bubble__meta">
        {who ?? DEFAULT_WHO[speaker]}
        {at != null && <> · {at}</>}
      </div>
    </div>
  );
}

/** Column wrapper that lays out a run of {@link ChatBubble}s. */
export function Transcript({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cx('tc-transcript', className)}>{children}</div>;
}
